import { paths } from '@issuemanager/apps/client/paths';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  useMonitorAddIssueTemplatesFormLoad,
  useMonitorCreateIssueFormLoad,
  useMonitorEditIssueTemplateFormLoad,
  useMonitorIssueTemplatesListLoad,
  useMonitorManageIssueFormLoad,
  useMonitorMasterIssuesList,
  useMonitorViewIssueLoad,
} from './targets';

// Start monitoring of certain actions based on the current route
// NOTE: Monitoring Pattern (Route-based)
export function useRoutesMonitoring() {
  const { pathname } = useLocation();

  const monitorMasterIssuesList = useMonitorMasterIssuesList();
  const monitorCreateIssueFormLoad = useMonitorCreateIssueFormLoad();
  const monitorViewIssueLoad = useMonitorViewIssueLoad();
  const monitorManageIssueLoad = useMonitorManageIssueFormLoad();
  const monitorIssueTemplatesListLoad = useMonitorIssueTemplatesListLoad();
  const monitorAddIssueTemplatesFormLoad =
    useMonitorAddIssueTemplatesFormLoad();
  const monitorEditIssueTemplateFormLoad =
    useMonitorEditIssueTemplateFormLoad();

  useEffect(() => {
    const viewIssueRegex = new RegExp(`/${paths.issues.index}/([0-9]{8}$)`);
    const manageIssueRegex = new RegExp(
      `/${paths.issues.index}/([0-9]{8})/${paths.issues.manage}`,
    );
    const issueTemplatesBasicPath = `/${paths.settings.index}/${paths.issueTemplates.index}`;
    const issueTemplatesEditRegex = new RegExp(
      `${paths.settings.index}/${paths.issueTemplates.index}/(.*)`,
    );
    if (['/', `/${paths.issues.master}`].includes(pathname)) {
      monitorMasterIssuesList.start();
    } else if (pathname === `/${paths.issues.create}`) {
      monitorCreateIssueFormLoad.start();
    } else if (viewIssueRegex.test(pathname)) {
      monitorViewIssueLoad.start();
    } else if (manageIssueRegex.test(pathname)) {
      monitorManageIssueLoad.start();
    } else if (pathname === issueTemplatesBasicPath) {
      monitorIssueTemplatesListLoad.start();
    } else if (
      pathname === `${issueTemplatesBasicPath}/${paths.issueTemplates.add}`
    ) {
      monitorAddIssueTemplatesFormLoad.start();
    } else if (issueTemplatesEditRegex.test(pathname)) {
      monitorEditIssueTemplateFormLoad.start();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
}
